import React from 'react';

import styles from './OAuthButton.module.scss';

interface IOAuthButtonProps {
    icon: React.ReactNode;
    label: React.ReactNode;
    onClick: () => void;
    isLoading?: boolean;
    disabled?: boolean;
}

const OAuthButton: React.FC<IOAuthButtonProps> = ({
    icon,
    label,
    onClick,
    isLoading = false,
    disabled = false,
}) => {
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled || isLoading}
            className={styles.button}
        >
            <span className={styles.icon}>{icon}</span>
            {label}
        </button>
    );
};

export default OAuthButton;
